import React, { useState } from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
import ChildTable from "./ChildTable";

function Row({ data }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr className={style.table_row}>
        <td className={style.table_cell}>
          <ButtonIcon
            bgColor={"#FF"}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className={`${isOpen ? style.collapse_button : ""}`}
          >
            <CaretRight />
          </ButtonIcon>
        </td>
        <td className={style.table_cell}>{data?.id}</td>
        <td className={style.table_cell}>
          {data?.batch_month} {data?.batch_year}
        </td>
        <td className={style.table_cell}>{data?.bhid}</td>
        <td className={style.table_cell}>{data?.terminal_id}</td>
        <td className={style.table_cell}>{data?.trans_cnt}</td>
        <td className={style.table_cell}>{data?.key_entry_cnt}</td>
        <td className={style.table_cell}>$ {data?.sales}.00</td>
        <td className={style.table_cell}>$ {data?.returns}.00</td>
        <td className={style.table_cell}>$ {data?.net_amt}.00</td>
        <td className={style.table_cell}>$ {data?.adjustment_amt}.00</td>
      </tr>
      {isOpen && <ChildTable data={data?.batches_data_details} />}
    </>
  );
}

export default Row;
